export const alertAutoCloseConfig = {
    timeout: 4000,

    autoCloseInfo: true,
    autoCloseSuccess: true,
    autoCloseWarning: true,
    autoCloseError: false,
};
